import { post } from '@/utils/request'

export default {
    pageList: query => post('/rrbi/course/getCoursePage', query),
    update: query => post('/rrbi/course/update',query),
    //select: id => post('/rrbi/course/select/' + id),
    delete: id => post('/rrbi/course/delete/' + id),

    select: id => post('/rrbi/coursefront/select/' + id),
    getOtherList: query => post('/rrbi/coursefront/getOtherList', query),
}